import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { useI18n } from '../../context/I18nContext';
import { authColors } from '../../styles/colors';

const CTA_BUTTON_CLASS = `w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 sm:px-8 py-3.5 sm:py-4 text-base font-semibold rounded-xl ${authColors.primaryGradient} text-white shadow-lg hover:shadow-xl hover:shadow-blue-500/30 transition-all duration-300 transform hover:scale-105 active:scale-95`;

interface PublicCtaSectionProps {
  href?: string;
  className?: string;
  titleKey?: string;
  descriptionKey?: string;
  buttonKey?: string;
  trustKey?: string;
}

const PublicCtaSection: React.FC<PublicCtaSectionProps> = ({
  href = '/signup',
  className = '',
  titleKey = 'landing.ctaTitle',
  descriptionKey = 'landing.ctaDescription',
  buttonKey = 'landing.ctaButton',
  trustKey = 'landing.trustSignup',
}) => {
  const { t } = useI18n();

  return (
    <section className={`relative py-14 sm:py-20 bg-white border-t border-slate-100 ${className}`}>
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-slate-900 mb-4 tracking-tight">
          {t(titleKey)}
        </h2>
        <p className="text-base sm:text-lg text-slate-600 mb-8 max-w-lg mx-auto leading-relaxed">
          {t(descriptionKey)}
        </p>
        <div className="flex flex-col items-center gap-3">
          <Link to={href} className={CTA_BUTTON_CLASS}>
            {t(buttonKey)}
            <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5" />
          </Link>
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-slate-50 border border-slate-200/80 text-xs sm:text-sm text-slate-600">
            <CheckCircle2 className="w-4 h-4 text-emerald-500 flex-shrink-0" />
            {t(trustKey)}
          </span>
        </div>
      </div>
    </section>
  );
};

export default PublicCtaSection;
